module.exports = __webpack_public_path__ + "img/icon-star.d450429f.svg";